import { upload } from "@vercel/blob/client";
import { authFetch } from "../../HttpClient";

// Appels à l'API de la GED (backend-myalfa, /api/ged).
const BASE = "https://backend-myalfa.vercel.app/api/ged";

async function appel(url, options) {
  const res = await authFetch(url, {
    ...options,
    headers: { "Content-Type": "application/json", ...(options && options.headers) },
  });
  if (!res.ok) {
    let message = `Erreur ${res.status}`;
    try {
      message = (await res.json()).message || message;
    } catch (e) {
      // corps non JSON : on garde le statut
    }
    throw new Error(message);
  }
  return res.json();
}

export const chargerGedApi = (clientId) => appel(`${BASE}/clients/${clientId}`);
export const deposerApi = (clientId, body) => appel(`${BASE}/clients/${clientId}/documents`, { method: "POST", body: JSON.stringify(body) });
export const creerSousDossierApi = (clientId, body) => appel(`${BASE}/clients/${clientId}/sous-dossiers`, { method: "POST", body: JSON.stringify(body) });
export const modifierDocumentApi = (id, body) => appel(`${BASE}/documents/${id}`, { method: "PATCH", body: JSON.stringify(body) });
export const supprimerDocumentApi = (id) => appel(`${BASE}/documents/${id}`, { method: "DELETE" });

// Envoi direct navigateur -> Vercel Blob ; le serveur ne reçoit que l'adresse.
// onProgress(octetsEnvoyés) suit l'envoi (barre de progression du dépôt).
export const televerser = (file, onProgress) =>
  upload(file.name, file, {
    access: "public",
    handleUploadUrl: `${BASE}/upload-token`,
    clientPayload: localStorage.getItem("token"),
    onUploadProgress: onProgress ? (e) => onProgress(e.loaded) : undefined,
  });
